module.exports = __webpack_public_path__ + "img/hotel-olissippo-marques-de-sa.3a403c21.jpg";